<label class="checkbox">
  <ng-content select="input"></ng-content>
  <span class="checkbox__decor"></span>
  <span class="checkbox__label">
    <ng-content select="checkbox-text"></ng-content>
  </span>
</label>
